import i18n from "@/i18n/config";

export enum ConversationType {
  ACCOUNTING = "ACCOUNTING",
  FUNDRAISING = "FUNDRAISING",
  VC_NAVIGATOR = "VC_NAVIGATOR",
  PRIVATE = "PRIVATE",
  PRIVATE_GROUP = "PRIVATE_GROUP",
  INTERNAL_CHANNEL = "INTERNAL_CHANNEL",
  DATA_ROOM = "DATA_ROOM",
  VIRTUAL_DATA_ROOM = "VIRTUAL_DATA_ROOM",
  SHARED_FINANCIALS = "SHARED_FINANCIALS",
  SINGLE_DOCUMENT = "SINGLE_DOCUMENT", // Single document virtual data room
  SINGLE_DOCUMENT_DATA_ROOM = "SINGLE_DOCUMENT_DATA_ROOM",
}

// Function to get translated conversation type name
const getConversationTypeTranslation = (translationKey: string): string => {
  return i18n.t(`chat:aiDrawer.conversationTypes.${translationKey}`);
};

export const ConversationTypePath = [
  {
    path: "/one/accounting",
    value: ConversationType.ACCOUNTING,
    get render() {
      return getConversationTypeTranslation("accounting");
    },
  },
  {
    path: "/one/fundraising",
    value: ConversationType.FUNDRAISING,
    get render() {
      return getConversationTypeTranslation("fundraising");
    },
  },
  {
    path: "/one/fundraising/smart-list",
    value: ConversationType.FUNDRAISING,
    get render() {
      return getConversationTypeTranslation("smartlist");
    },
  },
  {
    path: "/chat-bot",
    value: ConversationType.VC_NAVIGATOR,
    get render() {
      return getConversationTypeTranslation("vcNavigator");
    },
  },
  {
    path: "/one/communications",
    value: ConversationType.PRIVATE,
    get render() {
      return getConversationTypeTranslation("private");
    },
  },
  {
    path: "/one/communications",
    value: ConversationType.PRIVATE_GROUP,
    get render() {
      return getConversationTypeTranslation("privateGroup");
    },
  },
  {
    path: "/portal/inbox",
    value: ConversationType.INTERNAL_CHANNEL,
    get render() {
      return getConversationTypeTranslation("internalChannel");
    },
  },
  {
    path: "/portal/customers/details/accounting",
    value: ConversationType.ACCOUNTING,
    get render() {
      return getConversationTypeTranslation("accountingDetails");
    },
  },
  {
    path: "/one/data-room",
    value: ConversationType.DATA_ROOM,
    get render() {
      return getConversationTypeTranslation("dataRoom");
    },
  },
  {
    path: "/one/virtual-data-rooms/inside",
    value: ConversationType.VIRTUAL_DATA_ROOM,
    get render() {
      return getConversationTypeTranslation("sharedSpace");
    },
  },
  {
    path: "/one/virtual-data-rooms/financial-report",
    value: ConversationType.SHARED_FINANCIALS,
    get render() {
      return getConversationTypeTranslation("sharedFinancial");
    },
  },
  {
    path: "/one/virtual-data-rooms/file",
    value: ConversationType.SINGLE_DOCUMENT,
    get render() {
      return getConversationTypeTranslation("sharedFile");
    },
  },
];
